import {Button, Dropdown, RadioGroup} from "omoplay";
import React, {useEffect, useState} from "react";
import InputGroup from "../InputGroup";
import SuspensePopup from "../../SuspensePopup";
import TargetMessageForm from "../../volatility-message/TargetMessageForm";
import PasswordType from "../PasswordType";

export const AutomateMessageCondition = ({automateMessage, setAutomateMessage}) => {
    const [testMessagePopup, setTestMessagePopup] = useState(false)
    const [conditionDays, setConditionDays] = useState(automateMessage.conditionDays)
    const [sendHours, setSendHours] = useState(automateMessage.sendHours)
    const [sendMinutes, setSendMinutes] = useState(automateMessage.sendMinutes)
    const [passwordType, setPasswordType] = useState(automateMessage.passwordType)
    const [password, setPassword] = useState(automateMessage.password)

    useEffect(() => {
        automateMessage.conditionDays = conditionDays
        automateMessage.sendHours = sendHours
        automateMessage.sendMinutes = sendMinutes
        automateMessage.passwordType = passwordType
        automateMessage.password = password
        setAutomateMessage(automateMessage)
    }, [automateMessage, conditionDays, sendHours, sendMinutes, passwordType, password]);

    return (
        <>
            <InputGroup label="대상 조건 설정" description={
                <div className="flex-align-center justify-between">
                    <div>메시지 발송 대상을 확인 합니다.</div>
                    <Button variants="outlined" value="테스트 발송" onClick={() => setTestMessagePopup(true)} />
                </div>
            }>
                <div className="flex-col">
                    <div className="flex-col gap-4">
                        <div className="flex-col gap-4">
                            {
                                ["BIRTHDAY", "RETARGETING", "REMIND", "EXPIRED_COUPON", "FIRST_ANNIVERSARY"].includes(automateMessage.condition) &&
                                    <>
                                        <div className="flex-align-center gap-2">
                                            <div className="text-[20px]">고객에게</div>
                                            <input
                                                type="text"
                                                className="w-[50px] bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2"
                                                defaultValue={`${conditionDays}`}
                                                maxLength={2}
                                                onKeyUp={(e) => {
                                                    setConditionDays(e.currentTarget.value)
                                                }}
                                                onKeyDown={(e) => {
                                                    setConditionDays(e.currentTarget.value)
                                                }}
                                            />
                                            <div className="text-[20px]">일
                                                <span className="m-1 text-[20px]">
                                                    {
                                                        ["BIRTHDAY", "EXPIRED_COUPON", "FIRST_ANNIVERSARY"].includes(automateMessage.condition) ? "전" : "후"
                                                    }
                                                </span>
                                                메시지를 자동 발송합니다.</div>
                                        </div>
                                        <div className="flex-align-center gap-2">
                                            <div className="text-[20px]">발송 시간</div>
                                            <div className="flex items-center">
                                                <div className="mr-2">
                                                    <Dropdown variants="default"
                                                              initialValue={`${sendHours}`}
                                                              items={[{label: "08시", value: "8"},
                                                                  {label: "09시", value: "9"}, {label: "10시", value: "10"},
                                                                  {label: "11시", value: "11"}, {label: "12시", value: "12"},
                                                                  {label: "13시", value: "13"}, {label: "14시", value: "14"},
                                                                  {label: "15시", value: "15"}, {label: "16시", value: "16"},
                                                                  {label: "17시", value: "17"}, {label: "18시", value: "18"},
                                                                  {label: "19시", value: "19"}, {label: "20시", value: "20"},
                                                              ]}
                                                              onChanged={(items) => {
                                                                  setSendHours(items[0].value)
                                                              }}
                                                    />
                                                </div>
                                                <div>
                                                    <Dropdown variants="default"
                                                              initialValue={`${sendMinutes}`}
                                                              items={[
                                                                  {label: "00분", value: "0"}, {label: "05분", value: "5"},
                                                                  {label: "10분", value: "10"}, {label: "15분", value: "15"},
                                                                  {label: "20분", value: "20"}, {label: "25분", value: "25"},
                                                                  {label: "30분", value: "30"}, {label: "35분", value: "35"},
                                                                  {label: "40분", value: "40"}, {label: "45분", value: "45"},
                                                                  {label: "50분", value: "50"}, {label: "55분", value: "55"},
                                                              ]}
                                                              onChanged={(items) => {
                                                                  setSendMinutes(items[0].value)
                                                              }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-gray-500 text-[12px] my-2">
                                            * 광고성 메시지는 20:55부터 08:00까지 메시지 수신이 불가합니다.
                                        </div>
                                    </>
                            }
                            {
                                (automateMessage.condition === "PLACE_REVIEW" || automateMessage.condition === "KAKAO_MAP_REVIEW" || automateMessage.condition === "JOIN_TARGET" || automateMessage.condition === "CUSTOMER_POLL") && (
                                    <div className="flex-align-center gap-2">
                                        <div className="text-[20px]">방문 고객에게</div>
                                        <input
                                            type="text"
                                            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block p-2"
                                            style={{width: "50px"}}
                                            defaultValue={`${sendMinutes}`}
                                            maxLength={2}
                                            onKeyUp={(e) => {
                                                setConditionDays(e.currentTarget.value)
                                            }}
                                            onKeyDown={(e) => {
                                                setConditionDays(e.currentTarget.value)
                                            }}
                                        />
                                        <div className="text-[20px]">분
                                            <span className="m-1 text-[20px]">
                                                    {
                                                        automateMessage.condition === "BIRTHDAY" ? "전" : "후"
                                                    }
                                                </span>
                                            메시지를 자동 발송합니다.</div>
                                    </div>
                                )
                            }
                            {
                                automateMessage.condition === "RAINY_DAY" && (
                                    <div className="flex-align-center gap-2">
                                        <div className="text-[20px]">10시부터 12시까지 5mm 이상 비가 내릴 경우 메시지를 자동 발송합니다.</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </InputGroup>
            <InputGroup label={"연령 인증 메시지"}>
                <div className="flex-col justify-center gap-2">
                    <RadioGroup
                        items={[
                            {
                                label: "선택안함",
                                value: "N"
                            },
                            {
                                label: "선택함",
                                value: "Y"
                            }
                        ]}
                        initChecked={automateMessage.messageData.adult ?? "N"}
                        value={automateMessage.messageData.adult}
                        onSelected={(value) => {
                            automateMessage.messageData.adult = value
                            setAutomateMessage(automateMessage)
                        }}
                    />
                    <div>
                        <div className="font-12px">연령인증 전까지 채팅방 메시지에 커버가 씌워지며, 20세 이상 성인만 내용을 확인할 수 있습니다.</div>
                        <div className="font-12px">20세 이상에게 적합한 내용을 담고 있다면 필수 선택해주세요.</div>
                        <div className="font-12px">예: 주류, 청소년 이용불가 게임 및 영화 등</div>
                    </div>
                </div>
            </InputGroup>
            <InputGroup label="비밀번호 설정">
                <PasswordType
                    passwordType={passwordType ?? "NONE"}
                    benefitPassword={password}
                    onChangePassword={(password) => {
                        setPassword(password)
                    }}
                    onChangePasswordType={(passwordType) => {
                        setPasswordType(passwordType)
                    }}
                    onChangeValid={() => {}}
                />
            </InputGroup>
            <SuspensePopup
                title={"테스트 발송하기"}
                visible={testMessagePopup}
                style={{width: "1000px"}}
                onClose={() => setTestMessagePopup(false)}
            >
                <TargetMessageForm isTest={true}
                                   onSelectedUserIds={() => {}}
                                   messageData={automateMessage.messageData}
                                   automateId={automateMessage.id}
                                   onSendMessage={() => setTestMessagePopup(false)}

                />
            </SuspensePopup>
        </>
    );
};

export default AutomateMessageCondition;
